<angular2-multiselect *ngIf="loaded$ | async" [data]="getOptions()" [settings]="settings" [ngModel]="data.control.value"
                      (onOpen)="rotateArrowUpwards()" (onClose)="rotateArrowDownwards()"
                      (onSelect)="selectItem($event)" (onDeSelect)="deselectItem($event)"
                      (onSelectAll)="selectAllItems($event)" (onDeSelectAll)="deselectAllItems($event)"
                      [class]="{
                        'disabled': disabled,
                        'counter-only': counterOnly,
                        'arrow-downwards': arrowDownwards,
                        'arrow-upwards': arrowUpwards,
                      }">
  <c-badge *ngIf="counterOnly else badge">
    <ng-template>
      {{ 'general.selected' | transloco }}: {{ data.control.value?.length }} / {{ data.options.length }}
    </ng-template>
  </c-badge>
  <ng-template #badge>
    <c-badge>
      <ng-template let-item="item">
        <label>{{ translateLabels ? (item?.label | transloco) : item?.label }}</label>
      </ng-template>
    </c-badge>
  </ng-template>
  <c-item>
    <ng-template let-item="item">
      <label>{{ translateLabels ? (item?.label | transloco) : item?.label }}</label>
    </ng-template>
  </c-item>
</angular2-multiselect>
